<template>
  <div>
    <query-form label-width="90px">
      <template v-slot:formitem>
        <query-form-item :label="$t('openTools.boutiqueId')">
          <el-input clearable v-model="queryForm.boutiqueId"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.size')">
          <el-input clearable v-model="queryForm.size"></el-input>
        </query-form-item>
        <query-form-item :label="$t('openTools.barcode')">
          <el-input clearable v-model="queryForm.barcode"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.stock')">
          <el-select v-model="queryForm.stockStatus" clearable>
            <el-option :label="$t('openTools.inStock')" :value="1"></el-option>
            <el-option :label="$t('openTools.soldOut')" :value="0"></el-option>
          </el-select>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb20" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column prop="boutiqueId" :label="$t('openTools.boutiqueId')" min-width="150">
        <template slot-scope="scope">
          <el-link type="primary" @click="showJSON(scope.row)">{{ scope.row.boutiqueId }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="brandName" :label="$t('common.brand')" min-width="150"></el-table-column>
      <el-table-column :label="$t('common.category')" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.category1 }}{{ scope.row.category2 ? '/' + scope.row.category2 : ''
          }}{{ scope.row.category3 ? '/' + scope.row.category3 : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="designerId" :label="$t('common.designerId')" min-width="100">
        <template slot-scope="scope">
          <p class="keep-space">{{ scope.row.designerId }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="colorCode" :label="$t('common.color')" min-width="100">
        <template slot-scope="scope">
          <p class="keep-space">{{ scope.row.colorCode }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="seasonCode" :label="$t('common.season')" min-width="110"></el-table-column>
      <el-table-column prop="skuCode" :label="$t('openTools.barcode')" min-width="100"></el-table-column>
      <el-table-column :label="$t('openTools.image')" min-width="60">
        <template slot-scope="scope">
          <list-img :img="scope.row.image" :width="40"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="retailPrice" :label="$t('common.retailPrice')" min-width="100"></el-table-column>
      <el-table-column prop="supplyPrice" :label="$t('common.supplyPrice')" min-width="100"></el-table-column>
      <el-table-column prop="size" :label="$t('common.size')" min-width="100"></el-table-column>
      <el-table-column prop="stock" :label="$t('common.stock')" min-width="100"></el-table-column>
      <el-table-column :label="$t('openTools.createdAt')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.createAtTimeStamp | dateFormat('yyyy-MM-dd') }}<br />
          {{ scope.row.createAtTimeStamp | dateFormat('HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('openTools.updatedAt')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.lastCheckTimeStamp | dateFormat('yyyy-MM-dd') }}<br />
          {{ scope.row.lastCheckTimeStamp | dateFormat('HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.action')" fixed="right" width="300">
        <template slot-scope="scope">
          <el-link type="primary" v-if="!scope.row.productId" @click="createIMProduct(scope.row)">{{ $t('openTools.createTestProduct') }}</el-link>
          <el-link v-if="scope.row.productId && scope.row.stock > 0" type="primary" @click="createTestOrder(scope.row)">{{
            $t('openTools.createTestOrder')
          }}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="$t('openTools.sku')" :visible.sync="dialogVisible4" width="600px">
      <vue-json-pretty :data="skuJson"></vue-json-pretty>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import ListImg from '../../components/ListImg';
import { getProductList, createOrder, getProductDetail } from '../../api/openTools';

export default {
  name: 'OpenToolsProduct',
  components: {
    VueJsonPretty,
    ListImg,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      isen: false,
      queryForm: {
        boutiqueId: null,
        size: null,
        barcode: null,
        stockStatus: null,
        pageNo: 1,
        pageSize: 25,
      },
      skuJson: null,
      dialogVisible4: false,
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.boutiqueId = null;
      this.queryForm.size = null;
      this.queryForm.barcode = null;
      this.queryForm.stockStatus = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getProductList(this.queryForm).then((res) => {
        if (res.success && res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    createIMProduct(row) {
      window.location.href = `/goods/draft/edit?boutiqueProductId=${row.boutiqueProductId}&draft=1&fromDev=1&newPortal=1`;
    },
    createTestOrder(row) {
      createOrder({
        productId: row.productId,
        skuId: row.skuId,
      }).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          this.getTableData();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    showJSON(row) {
      getProductDetail({
        boutiqueProductId: row.boutiqueProductId,
      }).then((res) => {
        if (res.success && res.data) {
          this.skuJson = res.data;
          this.dialogVisible4 = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
